import axios from "axios";
import React, { useEffect, useContext, useReducer } from "react";
import reducer from "../reducers/modifyprod_reducer";

import {
  MODIFY_PRODUCT,
  UPDATE_PROF_ID,
  GET_PROF_DETAIL_BEGIN,
  GET_PROF_DETAIL_SUCCESS,
  GET_PROF_DETAIL_ERROR,
  SAVE_SUCCESS,
  RESET_PROD_STATE,
  DELETE_PROF_BEGIN,
  DELETE_PROF_SUCCESS,
  DELETE_PROF_ERROR
} from "../actions";

const initialState = {
  prof_loading: false,
  prof_error: false,
  product: "",
  profid: "",
  profUser: null,
  savedStatus: false,
};

const ModifyProdContext = React.createContext();

export const ModifyProdProvider = ({ children }) => {
  const restUrl = process.env.REACT_APP_REST_ENDPOINT;
  const rwUrl = process.env.REACT_APP_REST_ENDPOINT_REGSWATCH;
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (state.profid) {
      fetchProfDetail(state.product);
    }
  }, [state.profid, state.product]);

  const fetchProfDetail = async (product) => {
    const bearer_token = sessionStorage.getItem("latoken");
    const baseUrl = product === "regswatch" ? rwUrl : restUrl;
    const prodUrl = `${baseUrl}/professional/${state.profid}`;

    dispatch({ type: GET_PROF_DETAIL_BEGIN });
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${bearer_token}`,
        },
      };
      console.log("Fetching from:", prodUrl);
      const response = await axios.get(prodUrl, config);
      const profUserData = response.data.details;
      console.log(profUserData);
      dispatch({ type: GET_PROF_DETAIL_SUCCESS, payload: profUserData });
    } catch (error) {
      dispatch({ type: GET_PROF_DETAIL_ERROR });
    }
  };

  const updateId = (id) => {
    dispatch({ type: UPDATE_PROF_ID, payload: { id } });
  };

  const updateProduct = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    dispatch({ type: MODIFY_PRODUCT, payload: { name, value } });
  };

  const resetStateValues = () => {
    dispatch({ type: RESET_PROD_STATE, payload: { savedStatus: false } });
  };

  const saveProduct = async () => {
    const bearer_token = sessionStorage.getItem("latoken");
    const baseUrl = state.product === "regswatch" ? rwUrl : restUrl;
    const prodUrl = `${baseUrl}/professional/${state.profid}`;

    dispatch({ type: GET_PROF_DETAIL_BEGIN });
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${bearer_token}`,
        },
      };
      const response = await axios.put(
        prodUrl,
        { plan: state.product },
        config
      );
      const profUserData = response.data;
      dispatch({ type: SAVE_SUCCESS, payload: profUserData });
    } catch (error) {
      dispatch({ type: GET_PROF_DETAIL_ERROR });
    }
  };

  const deleteProduct = async(uid,plan) => {
    const bearer_token = sessionStorage.getItem("latoken");
    const baseUrl = plan === "regswatch" ? rwUrl : restUrl;
    const prodUrl = `${baseUrl}/professional/${uid}`;
    
    dispatch({type:DELETE_PROF_BEGIN});

    try{
      const config = {
        headers : {Authorization: `Bearer ${bearer_token}`}
      };
      const response = await axios.delete(prodUrl,config);
      // const Message = response.data;
      dispatch({ type: DELETE_PROF_SUCCESS, payload: uid });
     
    }
    catch(err){
      dispatch({type:DELETE_PROF_ERROR});
    }

  }

  return (
    <ModifyProdContext.Provider
      value={{
        ...state,
        updateProduct,
        updateId,
        saveProduct,
        deleteProduct,
        resetStateValues,
      }}
    >
      {children}
    </ModifyProdContext.Provider>
  );
};

export const useModifyProdContext = () => {
  return useContext(ModifyProdContext);
};
